<template lang="pug">
    section
        v-skeleton-loader(v-if='loading' type='card-avatar, article, actions')
        section(v-if='!loading')
            v-divider
            v-list-item(two-line='')
                    v-list-item-content
                        v-list-item-title(:title="userProfile.display_name") {{ userProfile.display_name }}
                        v-list-item-subtitle
                            v-btn(icon :to="{ name: 'logout'}" title="Выйти из аккаунта")
                                v-icon mdi-logout-variant
            v-divider
            v-list(two-line='')
                v-subheader
                    | Основные показатели
                v-list-item
                    v-list-item-content
                        v-list-item-title {{ userProfile.contract_sum[0] | toUSD }}
                        v-list-item-subtitle.amber--text.text--lighten-3 Сумма договора
                v-list-item
                    v-list-item-content
                        v-list-item-title {{ balance | toUSD }}
                        v-list-item-subtitle.amber--text.text--lighten-3 Свободный остаток
                v-list-item
                    v-list-item-content
                        v-list-item-title {{ userProfile.portfolio_cost | toUSD }}
                        v-list-item-subtitle.amber--text.text--lighten-3 Стоимость портфеля
                v-list-item
                    v-list-item-content
                        v-list-item-title {{ userProfile.deals_income | toUSD }}
                        v-list-item-subtitle.amber--text.text--lighten-3 Доход от совершенных сделок
                v-list-item
                    v-list-item-content
                        v-list-item-title {{ userProfile.profitability.toFixed(2) }} %
                        v-list-item-subtitle.amber--text.text--lighten-3 Доходность инвестиций
</template>

<script>
    export default {
        name: "ClientIndicators",
        computed: {
            userProfile() {
                return this.$store.state.client.userProfile
            },
            profitability() {
                return this.$store.getters.profitability
            },
            balance() {
                return this.$options.filters.toUSD(this.$store.getters.balance)
            },
        },
        data() {
            return {
                loading: true
            }
        },
        methods: {

        },
        created () {
            this.$store.dispatch('getClientProfile', this.$store.state.auth.user.id).then(() => {
                this.loading = false
            })
        }
    }
</script>

<style scoped>

</style>
